import React, { useState, useEffect } from "react";
import ExpandableSearchDropdown2 from "./ExpandableSearchDropdown2";
import TimeDropdown2 from "./TimeDropdown2";
import NoData from "./NoData";
const FilterRow2 = ({
  state,
  userRole,
  updateState,
  studentsFound,
  onClose,
  user,
}) => {
  const [mobileView, setMobileView] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth < 640);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={
        mobileView
          ? "flex flex-col gap-6 w-full justify-center items-center text-sm"
          : "flex items-center gap-3 sm:w-[65vw] lg:w-[50vw]"
      }
    >
      <div className={mobileView ? "flex flex-col w-full" : "flex flex-col sm:w-2/3 lg:w-3/4"}>
        <div className="text-base font-semibold">WHO</div>
        <div className="flex h-10 text-sm sm:text-[15px]">
          <ExpandableSearchDropdown2
            state={state}
            userRole={userRole}
            updateState={updateState}
            user={user}
            analyticsScope="educator_dashboard"
          />
        </div>
      </div>

      <div className={mobileView ? "flex flex-col w-full" : "flex flex-col sm:w-1/3 lg:w-1/4"}>
        <div className="text-base font-semibold">WHEN</div>
        <div className="flex h-10 text-sm sm:text-[15px]">
          <TimeDropdown2 state={state} updateState={updateState} />
        </div>
      </div>
      {state.studentEmotionData.length > 0 && mobileView && (
        <div className="mt-auto pt-6 w-[50%]">
          <button
            onClick={onClose}
            className="w-full bg-[#005BE2] text-white py-3 rounded-lg text-sm font-bold hover:bg-[#005BE2]/90 transition"
          >
            Show Students ({state.studentEmotionData.length})
          </button>
        </div>
      )}
      {state.studentEmotionData.length === 0 && mobileView && (
        <NoData
          hasStudents={state.currentStudents.length > 0}
          hasActivity={studentsFound}
          chosenStudent={state.chosenStudent}
        />
      )}
    </div>
  );
};

export default FilterRow2;
